import React, { useState, useEffect,useRef,useCallback } from 'react';
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  Typography,
  Grid,
  Chip,
  Tooltip
} from '@mui/material';
import { getRelativeTime } from './util';

import { Edit, Delete, ContentCopy, FileCopy , Archive } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ApiService from '../../API/Requesthandler'
import { reverse } from 'lodash';
const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editMessage, setEditMessage] = useState(null);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [filters, setFilters] = useState({
    dateFilter: 'all',
    statusFilter: 'all',
    typeFilter: 'all',
    searchText: ''
  });

  const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);


  

  const [formState, setFormState] = useState({
    message_id:"",
    sender: '',
    send_by: 'user',
    message_text: '',
    type: 'INSTANT',
    recipients: '',
    file_type: '',
    number_of_files: 0,
    status: 'PENDING',
    start_date: null,
    end_date: null,
    repeat_every: { value: 1, unit: 'day' }
  });


  const observer = useRef();
  const lastCampaignRef = useCallback(node => {
    if (isLoading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        fetchMessages(currentPage, 100);
      }
    });
    if (node) observer.current.observe(node);
  }, [isLoading, hasMore, currentPage]);
  // Mock API calls
  const fetchMessages = async (page,limit=100) => {

    setIsLoading(true)
    ApiService.get('/api/chat/get_messages/' + JSON.parse(localStorage.getItem("user-data"))['id'] + "/sent?page="+page+"&limit=100")
    .then(res =>{
        if (res.success){
          const msgs = res.data
            setMessages(
              prev => {
                const existingIds = new Set(prev.map(c => c.id));
                const filteredNew = msgs.filter(c => !existingIds.has(c.id));
                return page === 1 ? msgs : [...prev, ...filteredNew];
              }
            )
            setIsLoading(false);
            setHasMore(msgs.length >= limit);
            setCurrentPage(prev => page + 1);
        }else{
            setSnackbar({ open: true, message: 'Failed to load messages', severity: 'error' });
            setIsLoading(false);
            
            setHasMore(false);

        }
    }).catch(err=>{
        setSnackbar({ open: true, message: 'Failed to load messages', severity: 'error' });
        setIsLoading(false);
       
      setHasMore(false);
    })


   
  };




  const handleSubmit = async () => {
    try {
      if (editMessage) {
        
        setMessages(messages.map(msg => msg.id === editMessage.id ? 
          {...formState, id: msg.id, date_time: msg.date_time} : msg));
      }
      setSnackbar({ open: true, message: `Message updated!`, severity: 'success' });
      setOpenDialog(false);
    } catch (error) {
      setSnackbar({ open: true, message: 'Operation failed', severity: 'error' });
    }
  };

  const handleDelete = async (id) => {


    ApiService.post('/api/chat/set_archive',{"id":id})
    .then(res =>{
      // console.log(res)
      setSnackbar({ open: true, message: 'Message Archived', severity: 'success' });
      fetchMessages(1,100)
    }).catch(err =>{
      console.log(err)
      setSnackbar({ open: true, message: 'Archive failed', severity: 'error' });
    })

    
  };


  

  const handleCopyMessageText = (text) => {
    navigator.clipboard.writeText(text);
    setSnackbar({ open: true, message: 'Message text copied to clipboard!', severity: 'success' });
  };

  const handleDuplicateMessage = (message) => {
    const newMessage = {
      ...message,
      id: Date.now(), // Generate a new ID
      date_time: new Date().toISOString(), // Update the timestamp
      status: 'Pending' // Reset status to Pending
    };
    setMessages([...messages, newMessage]);
    setSnackbar({ open: true, message: 'Message duplicated!', severity: 'success' });
  };

  useEffect(() => {
    fetchMessages(1,100);
  }, []);

  const handleFormChange = (field, value) => {
    setFormState(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleEdit = (message) => {
    setEditMessage(message);
    setFormState(message);
    setOpenDialog(true);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const filteredMessages = messages.filter(message => {
    const matchesDateFilter = filters.dateFilter === 'all' || true; // Add date filtering logic
    const matchesStatusFilter = filters.statusFilter === 'all' || message.status === filters.statusFilter;
    const matchesTypeFilter = filters.typeFilter === 'all' || message.type === filters.typeFilter;
    const matchesSearchText = message.message_text.toLowerCase().includes(filters.searchText.toLowerCase());
    return matchesDateFilter && matchesStatusFilter && matchesTypeFilter && matchesSearchText;
  });

  return (
    <Container maxWidth="xxl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>Messages Activity</Typography>

      {/* Filters and Search Bar */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Date Filter</InputLabel>
            <Select
              value={filters.dateFilter}
              label="Date Filter"
              onChange={(e) => handleFilterChange('dateFilter', e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">This Week</MenuItem>
              <MenuItem value="month">This Month</MenuItem>
              <MenuItem value="year">This Year</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Status Filter</InputLabel>
            <Select
              value={filters.statusFilter}
              label="Status Filter"
              onChange={(e) => handleFilterChange('statusFilter', e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="SENT">Sent</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Type Filter</InputLabel>
            <Select
              value={filters.typeFilter}
              label="Type Filter"
              onChange={(e) => handleFilterChange('typeFilter', e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="INSTANT">Instant</MenuItem>
              <MenuItem value="SCHEDULE">Schedule</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Search Message Text"
            value={filters.searchText}
            onChange={(e) => handleFilterChange('searchText', e.target.value)}
          />
        </Grid>
      </Grid>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sent from</TableCell>
              <TableCell>Sent By</TableCell>
              <TableCell>Sent to</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Sent Date</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Trigger Event</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {1 == 3 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : filteredMessages.map((message,index) => (
              <TableRow key={message.id} ref={index === filteredMessages.length - 1 ? lastCampaignRef : null}>
                <TableCell>{message.sender}</TableCell>
                <TableCell>{message.send_by}</TableCell>
                <TableCell>
                    <Chip
                        label={message.recipients.length + " users" }
                        color={'default'}
                        variant="outlined"
                        /></TableCell>
                <TableCell sx={{ maxWidth: 300 }}>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {message.message_text}
                  </div>
                </TableCell>
                <TableCell sx={{ maxWidth: 300 }} >
                  {
                    message.type == "INSTANT" ? 
                    message.date_time
                    :
                    message.type == "SCHEDULE" ?
                    JSON.parse(message.filters.replaceAll("'",'"'))['start'] + " - " +JSON.parse(message.filters.replaceAll("'",'"'))['end'] : 
                    message.type == "POSTPOND" ? 
                    
                    JSON.parse(message.filters.replaceAll("'",'"'))['daterange'].map((el)=>{
                      return <Chip style={{margin:2}} label={el}  variant='outlined' color={message.status === 'SENT' || message.status === "COMPLETED" ? 'success' : message.status === "FAILED" ? "error" : "warning"}/>
                        
                      
                    })
                    : ""
                  }
                </TableCell>
                <TableCell>
                  <Chip
                    label={message.type === "POSTPOND" ? "POSTPONE" : message.type}
                    color={message.type === 'INSTANT' ? 'primary' : 'secondary'}
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={message.status}
                    color={message.status === 'SENT'  || message.status === "COMPLETED" ? 'success': message.status === "FAILED" ? "error" : "warning"}
                  />
                </TableCell>
                <TableCell>{getRelativeTime(message.date_time)}</TableCell>
                <TableCell>
                  {/* <Tooltip title="Edit">
                    <IconButton onClick={() => handleEdit(message)}>
                      <Edit />
                    </IconButton>
                  </Tooltip> */}
                  <Tooltip title="Delete">
                    <IconButton onClick={() => handleDelete(message.id)}>
                      <Delete color="error" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Copy Message Text">
                    <IconButton onClick={() => handleCopyMessageText(message.message_text)}>
                      <ContentCopy />
                    </IconButton>
                  </Tooltip>
                  {/* {message.type === 'SCHEDULE' && (
                    <Tooltip title="Duplicate">
                      <IconButton onClick={() => handleDuplicateMessage(message)}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                  )} */}

                    
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
      </TableContainer>

      
      {isLoading && (
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                  </Grid>
                )}
      {/* Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Edit Message</DialogTitle>
        <DialogContent sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <TextField
            fullWidth
            label="Message Text"
            multiline
            rows={4}
            value={formState.message_text}
            onChange={(e) => handleFormChange('message_text', e.target.value)}
          />
          {formState.type === 'SCHEDULE' && (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Start Date"
                  value={formState.start_date}
                  onChange={(date) => handleFormChange('start_date', date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
                <DatePicker
                  label="End Date"
                  value={formState.end_date}
                  onChange={(date) => handleFormChange('end_date', date)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Repeat Every"
                    type="number"
                    value={formState.repeat_every.value}
                    onChange={(e) => handleFormChange('repeat_every', {
                      ...formState.repeat_every,
                      value: Math.max(1, parseInt(e.target.value) || 1)
                    })}
                    InputProps={{ inputProps: { min: 1 } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Unit</InputLabel>
                    <Select
                      value={formState.repeat_every.unit}
                      label="Unit"
                      onChange={(e) => handleFormChange('repeat_every', {
                        ...formState.repeat_every,
                        unit: e.target.value
                      })}
                    >
                      <MenuItem value="second">Second</MenuItem>
                      <MenuItem value="minute">Minute</MenuItem>
                      <MenuItem value="hour">Hour</MenuItem>
                      <MenuItem value="day">Day</MenuItem>
                      <MenuItem value="week">Week</MenuItem>
                      <MenuItem value="month">Month</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

// Mock data
const mockMessages = [
  {
    id: 1,
    sender: "John Doe",
    message_text: "Please review the Q4 report",
    type: "INSTANT",
    status: "Delivered",
    date_time: "2024-02-20T15:30:00"
  },
  {
    id: 2,
    sender: "System Notification",
    message_text: "Scheduled maintenance tonight at 10 PM",
    type: "SCHEDULE",
    status: "Pending",
    date_time: "2024-02-20T16:45:00",
    start_date: "2024-02-20T22:00:00",
    end_date: "2024-02-21T02:00:00",
    repeat_every: { value: 1, unit: 'day' }
  }
];

export default MessagesPage;